import { VFC } from 'react'
import { useParams } from 'react-router-dom'

import useWorkflow from '../shared/hooks/useWorkflow'
import TasksList from './components/TasksList'

const Container: VFC = () => {
  const { workflowUuid } = useParams()

  const { workflow, isFetching } = useWorkflow({ workflowUuid })

  if (isFetching) {
    return null
  }

  return (
    <div>
      {workflow?.uuid}
      <br />
      <br />
      {workflow && <TasksList workflow={workflow} />}
    </div>
  )
}

export default Container
